import moment from 'moment';
import config from '../../config';

export const CAMPAIGN_TYPE = {
  promotion: 'promotion',
  update: 'update',
  recurring: 'recurring',
};

export const AUDIENCE_TYPE = {
  all: 'all',
  lapsing: 'lapsing',
  new: 'new',
  service: 'service',
  regular: 'regular',
  barber: 'barber',
  shop: 'shop',
  prospective: 'prospective',
};

export const DEFAULT_TIME = moment('12:00', 'HH:mm').format(config.timeFormat);

export const CAMPAIGN_FILTER_ALL = 'all';

export const subjectInputId = 'campaign-subject-input';

// Actions
export const RESET_CAMPAIGN = 'RESET_CAMPAIGN';
export const SET_CAMPAIGN = 'SET_CAMPAIGN';
export const SET_CAMPAIGN_TYPE = 'SET_CAMPAIGN_TYPE';
export const SET_CAMPAIGN_PROMO_ID = 'SET_CAMPAIGN_PROMO_ID';
export const CLEAR_PROMO = 'CLEAR_PROMO';
export const SET_CAMPAIGN_CUSTOMER_GROUP = 'SET_CAMPAIGN_CUSTOMER_GROUP';
export const TOGGLE_CAMPAIGN_CUSTOMER_GROUP = 'TOGGLE_CAMPAIGN_CUSTOMER_GROUP';
export const SET_CAMPAIGN_SUBJECT = 'SET_CAMPAIGN_SUBJECT';
export const SET_CAMPAIGN_BODY = 'SET_CAMPAIGN_BODY';
export const SET_CAMPAIGN_COLOR = 'SET_CAMPAIGN_COLOR';
export const TOGGLE_CAMPAIGN_SEND_EMAIL = 'TOGGLE_CAMPAIGN_SEND_EMAIL';
export const TOGGLE_CAMPAIGN_SEND_SMS = 'TOGGLE_CAMPAIGN_SEND_SMS';
export const TOGGLE_CAMPAIGN_SEND_PUSH = 'TOGGLE_CAMPAIGN_SEND_PUSH';
export const SET_CAMPAIGN_LOGO = 'SET_CAMPAIGN_LOGO';
export const SET_CAMPAIGN_LOGO_IMAGE = 'SET_CAMPAIGN_LOGO_IMAGE';
export const SET_CAMPAIGN_BACKGROUND = 'SET_CAMPAIGN_BACKGROUND';
export const SET_CAMPAIGN_BACKGROUND_IMAGE = 'SET_CAMPAIGN_BACKGROUND_IMAGE';
export const SET_FETCHING = 'ENGAGEMENT_SET_FETCHING';
export const SET_CUSTOMER_GROUPS = 'ENGAGEMENT_SET_CUSTOMER_GROUPS';
export const SET_NEW_CUSTOMER_GROUP_WEEKS = 'ENGAGEMENT_SET_NEW_CUSTOMER_GROUP_WEEKS';
export const SET_SERVICE_CUSTOMER_GROUP_SERVICE_ID = 'SET_SERVICE_CUSTOMER_GROUP_SERVICE_ID';
export const SAVE_CAMPAIGN = 'SAVE_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';
export const SET_SCHEDULED_AT = 'ENGAGEMENT_SET_SCHEDULED_AT';
export const CLEAR_CAMPAIGN_LIST = 'CLEAR_CAMPAIGN_LIST';
export const FETCH_CAMPAIGN_LIST = 'FETCH_CAMPAIGN_LIST';
export const FETCH_CAMPAIGN = 'FETCH_CAMPAIGN';
export const SET_CAMPAIGN_OWNER_ID = 'SET_CAMPAIGN_OWNER_ID';
export const SET_CAMPAIGN_OWNER_TYPE = 'SET_CAMPAIGN_OWNER_TYPE';
export const SET_FILTER = 'ENGAGEMENT_SET_FILTER';
export const SET_SEARCH_STRING = 'ENGAGEMENT_SET_SEARCH_STRING';
export const SET_RECURRING_START_DATE = 'SET_RECURRING_START_DATE';
export const SET_RECURRING_END_DATE = 'SET_RECURRING_END_DATE';
export const SET_RECURRING_TIME = 'SET_RECURRING_TIME';
export const SET_RECURRING_FREQUENCY = 'SET_RECURRING_FREQUENCY';
export const SET_RECURRING_SEND_TO_ALL_CUSTOMERS = 'SET_RECURRING_SEND_TO_ALL_CUSTOMERS';
export const SET_RECURRING_DAY = 'SET_RECURRING_DAY';
